import React, { createContext, useState, useContext, useEffect } from 'react';
import '../App.css';
import Cookies from 'js-cookie'; // Import js-cookie


// Create the context
const DarkModeContext = createContext();

// Provider component
export const DarkModeProvider = ({ children }) => {
    // Initialize dark mode state from cookies, default to false if not set
    const [darkMode, setDarkMode] = useState(() => {
        const savedMode = Cookies.get('darkMode'); // Retrieve from cookies
        return savedMode === 'true'; // Convert string to boolean
    });
    // Effect to change background and text color when darkMode state changes
    useEffect(() => {
        if (darkMode) {
            document.body.classList.add("dark");  // Add the "dark" class to body
            document.body.classList.remove("light");  // Remove the "light" class from body
        } else {
            document.body.classList.add("light");  // Add the "light" class to body
            document.body.classList.remove("dark");  // Remove the "dark" class from body
        }
        // Save the state in cookies whenever it changes
        Cookies.set('darkMode', darkMode.toString(), { expires: 365 }); // Persist for 1 year
    }, [darkMode]);

    const toggleDarkMode = () => {
        setDarkMode(!darkMode); // Toggle dark mode
    };

    return (
        <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
            {children}
        </DarkModeContext.Provider>
    );
};

// Custom hook to use dark mode context
export const useDarkMode = () => {
    return useContext(DarkModeContext);
};